import { styled } from 'linaria/react';

export const PriceBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: var(--space-75);
  width: 27.5%;
  margin-left: auto;

  & > div {
    justify-content: flex-end;

    @media (--only-mobile) {
      justify-content: flex-start;
    }
  }

  @media (max-width: 1100px) {
    width: 35.5%;
  }

  @media (--only-mobile) {
    align-items: flex-start;
    width: 100%;
  }
`;
